import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { VentanillaUACModel } from 'src/app/models/ventanillaUAC.model';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';

export class DatosVentanilla {
    ventanilla: string;
    sede: string;
}

@Component({
    selector: 'app-seleccion-ventanilla',
    templateUrl: './seleccion-ventanilla.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
    ]
})
export class SeleccionVentanillaComponent implements OnInit {

    datosVentanilla: DatosVentanilla = new DatosVentanilla();
    sedes: DetalleDominio[];
    ventanillas: VentanillaUACModel[];
    ventanillasFiltro: VentanillaUACModel[];
    tipoDocumento: string;
    numeroDocumento: string;

    constructor(
        private activeModal: NgbActiveModal,
        private spinner: NgxSpinnerService,
        private global: GlobalService,
        private urlService: UrlService,
        private utilService: UtilService,
        private alertService: AlertService
    ) { }

    ngOnInit() {
        
        this.datosVentanilla.sede = sessionStorage.getItem(ConstantesService.SEDE_DEFECTO_SESSSION);
        this.consultaSedes();
        this.consultarVentanillas();
    }

    /**
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     */
    consultaSedes() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this.sedes = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    consultarVentanillas() {
        this.spinner.show();
        const serviceProvider = 'consultarConfiguracionFuncionario';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoIdFuncionario', sessionStorage.getItem('tipoDocumento')]);
        queryParams.push(['numeroIdFuncionario', sessionStorage.getItem('numDocumento')]);
        let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this.ventanillas = data;
                this.filtrarVentanillas();
            }, err => {
                this.catchException('Ocurrio un error en la consulta de ventanillas configurdadas para el funcionario');                
            }
        );

    }

    filtrarVentanillas() {
        if(this.ventanillas.length === 0){
            this.catchException('No existen ventanillas configuradas para su usuario, por favor remitase al administrador de la UAC');
            return;
        }

        this.ventanillasFiltro = this.ventanillas.filter(ventanilla => ventanilla.ventanillaUacPK.sede
            === this.datosVentanilla.sede);

        if(this.ventanillasFiltro.length === 0 ){
            this.catchException('No existen ventanillas configuradas para la sede seleccionada.');
        }
    }

    cargarDatos() {      
        this.activeModal.close(this.datosVentanilla);
        
    }

    /**
     * Método de control de Excepciones
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }

    validarBotones() {
        return this.utilService.validarCamposObligatorios(this.datosVentanilla.ventanilla)
          && this.utilService.validarCamposObligatorios(this.datosVentanilla.sede);
    }
}
